<template>

<div class='ld-over'>
    <img class='ld-over-img' src='/resources/loader.svg' width="20%">
</div>


</template>

<script>
    export default {

        mounted() {

        },

        created() {
           
        },

        data() {
            return {
                isReady : false,
            }
        },

        methods : {

        }

    }
</script>
<style type="text/css">
.ld-over{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.3);
    z-index: 9999;
}

.ld-over-img {
    margin: auto;
    position: absolute;
    left: 40%;
    top : 20%;
}
</style>